export const FORUM_TOPICS_RESET_STATE = 'FORUM_TOPICS_RESET_STATE';
export const FORUM_TOPICS_CURRENT_ITEM = 'FORUM_TOPICS_CURRENT_ITEM';

export const FORUM_TOPICS_REQUEST_LOADING = 'FORUM_TOPICS_REQUEST_LOADING';
export const FORUM_TOPICS_REQUEST_SUCCESS = 'FORUM_TOPICS_REQUEST_SUCCESS';
export const FORUM_TOPICS_REQUEST_FAILED = 'FORUM_TOPICS_REQUEST_FAILED';

export const FORUM_TOPICS_CURRENT_ACTION = 'FORUM_TOPICS_CURRENT_ACTION';
export const FORUM_TOPICS_RESET_ACTION = 'FORUM_TOPICS_RESET_ACTION';